import { Link } from "react-router-dom"
import Input from "../../blocks/Input"
import { useForm } from "../../hooks/useForm"
import './payment-header.css'
import PaymentModal from "../Modals/Payment-modal"
import { useRef, useState } from "react"
import context from "../../scripts/context"
import RefreshIcon from '@mui/icons-material/Refresh';
import IconButton from '@mui/material/IconButton';
import * as React from 'react';
import { useNavigate } from "react-router-dom"




import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';

const PaymentHeader = ({ onFilter, onExport, count, onRefresh }) =>  {

    const paymentModal = useRef()
    const navigate = useNavigate()
    const [inputs, setInputs] = useState(context.getPaymentInputFilter())
    const onPaymentInputFilter = (ins) => {
        setInputs({
            ...ins
         })
    }
    context.addListenerPaymentInputFilter((ins)=>{onPaymentInputFilter(ins)})

    const openModal = () => paymentModal.current.openModal()
    const options = ['Create link', 'Create by PNR'];
    const posOptions = ['POS Link', 'POS Link by PNR'];

    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);
    const [posOpen, setPosOpen] = React.useState(false);
    const posAnchorRef = React.useRef(null);
    const [selectedIndex, setSelectedIndex] = React.useState(0);
    const [posSelectedIndex, setPosSelectedIndex] = React.useState(0);

    const handleClick = () => {
        console.info(`You clicked ${options[selectedIndex]}`);
        if(selectedIndex === 0){
            navigate("/agent/payments/single",  {replace: true, state: {type: 'create'}})
        }

        if(selectedIndex === 1){
          navigate("/agent/payments/by-pnr", {replace: true, state: {type: 'create'}})
        }
    }
    ;

    const posHandleClick = () => {
      console.info(`You clicked ${posOptions[selectedIndex]}`);
      if(posSelectedIndex === 0){
        navigate("/agent/payments/pos-payment",  {replace: true, state: {type: 'create'}})
      }

      if(posSelectedIndex === 1){
        navigate("/agent/payments/by-pnr", {replace: true, state: {type: 'create', paymentType: 'pos'}})
      }
  }
  ;

    const handleMenuItemClick = (event, index) => {
        setSelectedIndex(index);
        if(index === 0){
            navigate("/agent/payments/single",  {replace: true, state: {type: 'create'}})
        }
        if(index === 1){
          navigate("/agent/payments/by-pnr", {replace: true, state: {type: 'create', paymentType: 'link'}})
        }
        setOpen(false);
    };

    const posHandleMenuItemClick = (event, index) => {
      setPosSelectedIndex(index);
      if(index === 0){
          navigate("/agent/payments/pos-payment",  {replace: true, state: {type: 'create'}})
      }
      if(index === 1){
        navigate("/agent/payments/by-pnr", {replace: true, state: {type: 'create', paymentType: 'pos'}})
      }
      setPosOpen(false);
  };


    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };
    const posHandleToggle = () => {
        setPosOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
        return;
        }

        setOpen(false);
    };
    const posHandleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
        return;
        }

        setPosOpen(false);
    };

    const handleSearchChange = (value, name)=>{
        const ni = {
            ...inputs,
            [name]: {
                ...inputs.id,
                value: value
            },
        }
        setInputs(ni)
        context.setPaymentInputFilter(ni)
    }

    const checkEnter = (event) => {
        if (event.keyCode === 13) {
            onFilter(inputs)
        }
    };
    const exportCsv = async ()=>{
        onExport()
    }

    const goToRefund = () =>  navigate("/agent/payments/refund", {replace: true})
    


    return(
        <div className="payment-searchbar">
            <div onClick={onRefresh}>
                <IconButton>
                    <img src="/images/refresh.svg"></img>
                </IconButton>
            </div>
            <div className="payment-searchbar__input">
                <Input inputField={inputs.id} onChange={handleSearchChange} onKeyDown={e=> checkEnter(e)}/>
            </div>
            <div className="payment-searchbar__filter">
                <button onClick={openModal}>Filter {(count!== 0 ? <span>{count}</span> : '')}</button>
            </div>
            <div className="payment-searchbar__export">
                <button onClick={()=>exportCsv()}>Export</button>
            </div>
            <div className="payment-searchbar__btn">
                {/* <Link to={"/agent/payments/single"} state={{type: "create"}}>
                    <button>Create payment</button>
                </Link> */}
                <ButtonGroup variant="contained" ref={anchorRef} aria-label="split button" id= 'btn-1'>
                    <Button onClick={handleClick}>{options[selectedIndex]}</Button>
                    <Button
                    size="small"
                    aria-controls={open ? 'split-button-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-label="select merge strategy"
                    aria-haspopup="menu"
                    onClick={handleToggle}
                    >
                    <ArrowDropDownIcon />
                    </Button>
                </ButtonGroup>
                <Popper
                  sx={{
                    zIndex: 1,
                  }}
                  open={open}
                  anchorEl={anchorRef.current}
                  role={undefined}
                  transition
                  disablePortal
                >
                  {({ TransitionProps, placement }) => (
                  <Grow
                    {...TransitionProps}
                    style={{
                      transformOrigin:
                        placement === 'bottom' ? 'center top' : 'center bottom',
                    }}
                  >
                    <Paper>
                      <ClickAwayListener onClickAway={handleClose}>
                        <MenuList id="split-button-menu" autoFocusItem>
                          {options.map((option, index) => (
                            <MenuItem
                              key={option}
                              disabled={index === 2}
                              selected={index === selectedIndex}
                              onClick={(event) => handleMenuItemClick(event, index)}
                            >
                              {option}
                            </MenuItem>
                          ))}
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>

            </div>
            <div className="payment-searchbar__pos">
                {/* <Link to={"/agent/payments/single"} state={{type: "create"}}>
                    <button>Create payment</button>
                </Link> */}
                <ButtonGroup variant="contained" ref={posAnchorRef} aria-label="split button" id = 'btn-2'>
                    <Button onClick={posHandleClick}>{posOptions[posSelectedIndex]}</Button>
                    <Button
                    size="small"
                    aria-controls={posOpen ? 'split-button-menu' : undefined}
                    aria-expanded={posOpen ? 'true' : undefined}
                    aria-label="select merge strategy"
                    aria-haspopup="menu"
                    onClick={posHandleToggle}
                    >
                    <ArrowDropDownIcon />
                    </Button>
                </ButtonGroup>
                <Popper
                  sx={{
                    zIndex: 1,
                  }}
                  open={posOpen}
                  anchorEl={posAnchorRef.current}
                  role={undefined}
                  transition
                  disablePortal
                >
                  {({ TransitionProps, placement }) => (
                  <Grow
                    {...TransitionProps}
                    style={{
                      transformOrigin:
                        placement === 'bottom' ? 'center top' : 'center bottom',
                    }}
                  >
                    <Paper>
                      <ClickAwayListener onClickAway={posHandleClose}>
                        <MenuList id="split-button-menu" autoFocusItem>
                          {posOptions.map((option, index) => (
                            <MenuItem
                              key={option}
                              disabled={index === 2}
                              selected={index === posSelectedIndex}
                              onClick={(event) => posHandleMenuItemClick(event, index)}
                            >
                              {option}
                            </MenuItem>
                          ))}
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>

            </div>
            <div className="refund">
              <button className="refund-btn" onClick={goToRefund}>REFUND LINK</button>
            </div>
            <PaymentModal ref={paymentModal} onFilter={ (inputs) => { setInputs(inputs); onFilter(inputs);}} />
        </div>
    )
    
}
export default PaymentHeader